<template>
   <v-select
      v-model="localValue"
      :items="items"
      :label="`${required ? '* ' + label : label}`"
      :loading="loading"
      :item-text="itemText"
      :item-value="itemValue"
      :rules="
         required ? [() => !!localValue || `${label} es requerido.`] : []
      "
      :error="pushError"
      :class="'custom'"
   ></v-select>
</template>

<script>
//Mixins
import vmodel from '../js/mixins/vmodel'

export default {
   mixins: [vmodel],
   props: {
      pushError: { type: Boolean },
      itemValue: { type: String },
      itemText: { type: String },
      loading: { type: Boolean },
      required: { type: Boolean }
   }
}
</script>

<style scoped>
.custom >>> input {
   font-size: 1.2em;
}
.custom >>> label {
   font-size: 1.2em;
}
</style>
